import ProposedSourceChip from "./ProposedSourceChip";

export default ProposedSourceChip;
